<div class="m-subheader" appunwraptag="">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title notranslate">
                My Profile
            </h3>
        </div>
    </div>
</div>

<div class="m-content" style="padding-right: 25px!important;">
    <div class="m-portlet m-portlet--mobile">
        <div class="m-portlet">
            <div class="">
                <div class="row">
                    <div class="col-xl-3 col-lg-4">
                        <div class="m-portlet m-portlet--full-height  ">
                            <div class="m-portlet__body">
                                <div class="m-card-profile">
                                    <div class="m-card-profile__title m--hide">
                                        Your Profile
                                    </div>
                                    <div class="m-card-profile__pic">
                                        <div class="m-card-profile__pic-wrapper">
                                            <img src="../../../assets/images/user1.png" alt="">
                                        </div>
                                    </div>
                                    <div class="m-card-profile__details">
                                        <span class="m-card-profile__name">Agency
                                            {{assessmentAgencyData && assessmentAgencyData.name ? assessmentAgencyData.name : ''}}</span>
                                        <a target="_blank" rel="noopener"
                                            class="m-card-profile__email m-link">{{website?website: ''}}</a>
                                        <a class="m-card-profile__email m-link">Email:
                                            {{assessmentAgencyData && assessmentAgencyData.email ? assessmentAgencyData.email: 'N/A'}}</a><br>
                                        <a class="m-card-profile__email m-link">Mobile:
                                            {{assessmentAgencyData && assessmentAgencyData.spoc.mobileNumber ? assessmentAgencyData.spoc.mobileNumber: 'N/A'}}</a>
                                    </div>
                                </div>
                                <hr>
                                <div class="offset-2 m-card-profile__details text-margin">
                                    <span class="profile-text"><i class="fa flaticon-user icon-margin notranslate"></i>
                                        My Profile</span><br>
                                    <span><i class="flaticon-support icon-margin"></i> Help & Support</span>
                                </div>
                                <hr>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-9 col-lg-8">
                        <div class="m-portlet m-portlet--full-height m-portlet--tabs  ">
                            <div class="m-portlet__head">
                                <div class="m-portlet__head-tools">
                                    <ul class="nav nav-tabs m-tabs m-tabs-line   m-tabs-line--left m-tabs-line--primary"
                                        role="tablist">
                                        <li class="nav-item m-tabs__item">
                                            <a class="nav-link m-tabs__link active" data-toggle="tab"
                                                href="#assigned-job-roles" role="tab">
                                                <i class="flaticon-share m--hide"></i> &emsp;&emsp;General
                                                Details&emsp;&emsp;
                                            </a>
                                        </li>
                                        <li class="nav-item m-tabs__item">
                                            <a class="nav-link m-tabs__link" data-toggle="tab" href="#certifications"
                                                role="tab">
                                                &emsp;&emsp;Financial Details&emsp;&emsp;
                                            </a>
                                        </li>
                                        <li class="nav-item m-tabs__item">
                                            <a class="nav-link m-tabs__link" data-toggle="tab" href="#education"
                                                role="tab">
                                                &emsp;&emsp;Associations&emsp;&emsp;
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="m-portlet__head-tools">
                                    <h3 class="m-portlet__head-text">
                                        <span class="push-right">
                                            <!-- <button type="button" class="btn btn-secondary" (click)="editProfile()">
														Edit Profile
													</button> -->
                                            <button type="button" class="btn btn-secondary" (click)="goBack()">
                                                Back
                                            </button>
                                        </span>
                                    </h3>
                                </div>
                            </div>
                            <div class="tab-content">
                                <div class="tab-pane active" id="assigned-job-roles">
                                    <form class="m-form m-form--fit m-form--label-align-right notranslate"
                                        [formGroup]="assessmentAgencyDataForm">
                                        <div class="m-portlet__body">
                                            <div>
                                                <div class="m-content">
                                                    <h5 class="padding">
                                                        General Details
                                                    </h5>
                                                </div>
                                                <div class="m-portlet__body">
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Name of the Assessment
                                                                Agency :</label>
                                                            <input type="email" formControlName="name" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                            <!-- <span class="m-form__help metaLink-style">View Profile Details</span> -->
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Assessment Agency ID
                                                                :</label>
                                                            <input type="email" formControlName="userName" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Type of AA :</label>
                                                            <input type="email" formControlName="type" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Overall Experience :</label>
                                                            <input type="email" formControlName="overAllExperience"
                                                                disabled class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">AA Affiliation :</label>
                                                            <input type="email"
                                                                formControlName="AssessmentAgencyAffiliation" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Affiliated with other SSC
                                                                :</label>
                                                            <input type="email" formControlName="affiliatedWithOtheSSC"
                                                                disabled class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Mode of Assessment:</label>
                                                            <!-- <input formControlName="modeOfAssessment" type="email" class="form-control m-input m-input--solid" id="exampleInputEmail1"
																 aria-describedby="emailHelp" > -->
                                                            <!-- <select multiple="" class="form-control m-input m-input--air" id="exampleSelect2">
																<option *ngFor="let ass of assessmetModeList" [value]="ass">{{ass}}</option>
															</select> -->
                                                            <input type="email" formControlName="modeOfAssessment"
                                                                disabled class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">

                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Proficiency in
                                                                Language:</label>
                                                            <!-- <select multiple="" class="form-control m-input m-input--air" id="exampleSelect2">
																<option *ngFor="let lang of languageList" [value]="lang">{{lang}}</option>
															</select> -->

                                                            <input type="email" formControlName="languagesForAssessment"
                                                                disabled class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>
                                                    <div class="row" formGroupName="isoCertificationDetail">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">ISO Certification :</label>
                                                            <input type="email" formControlName="isoCertified" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Upload ISO Certification
                                                                Documents :</label>
                                                            <p class="form-control m-input m-input--solid file-clickable"
                                                                (click)="previewIsoDoc()">Preview ISO Certification
                                                                Document</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-content">
                                                    <h5 class="padding">
                                                        Single Point of Contact Info:
                                                    </h5>

                                                </div>
                                                <div class="m-portlet__body" formGroupName="spoc">
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Name of the SPOC :</label>
                                                            <input type="email" formControlName="firstName" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                            <!-- <span class="m-form__help metaLink-style">View Profile Details</span> -->
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label for="exampleInputEmail1">Email Address :</label>
                                                            <input type="email" formControlName="email" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label for="exampleInputEmail1">Phone Number :</label>
                                                            <input type="email" formControlName="mobileNumber" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="m-content">
                                                    <h5 class="padding">
                                                        Address Details:
                                                    </h5>

                                                </div>
                                                <div class="m-portlet__body" formGroupName="address">
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Address :</label>
                                                            <textarea class="form-control m-input m-input--air"
                                                                formControlName="address1" disabled id="exampleTextarea"
                                                                rows="3"></textarea>
                                                        </div>
                                                        <div class="col-lg-6"
                                                            formGroupName="yearOfEstablishmentDetails">
                                                            <label for="exampleInputEmail1">Incorporation Year :</label>
                                                            <input type="email" formControlName="year"
                                                                class="form-control m-input m-input--solid" disabled
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                    </div>

                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Nearby Landmark :</label>
                                                            <input type="email" formControlName="landmark" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Pincode :</label>
                                                            <input type="email" formControlName="pinCode" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6"
                                                            formGroupName="state">
                                                            <label for="exampleInputEmail1">State / Union Territory
                                                                :</label>
                                                            <input type="email" formControlName="name" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6" formGroupName="district">
                                                            <label for="exampleInputEmail1">District :</label>
                                                            <input type="email" formControlName="name" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6"
                                                            formGroupName="mandal">
                                                            <label for="exampleInputEmail1">Tehsil / Mandal /Block
                                                                :</label>
                                                            <input type="email" formControlName="name" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6" formGroupName="city">
                                                            <label for="exampleInputEmail1">City / Village / Town
                                                                :</label>
                                                            <input type="email" formControlName="name" disabled
                                                                class="form-control m-input m-input--solid"
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6"
                                                            formGroupName="parliamentConstituency">
                                                            <label for="exampleInputEmail1">Parliamentary Constituency
                                                                :</label>
                                                            <input type="email" formControlName="name"
                                                                class="form-control m-input m-input--solid" disabled
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Address Proof :</label>
                                                            <p class="form-control m-input m-input--solid file-clickable"
                                                                disabled (click)="viewAddressProof()">Address Proof
                                                                Document</p>

                                                        </div>

                                                    </div>
                                                </div>

                                                <div class="m-content">
                                                    <h5 class="padding">
                                                        Other Information:
                                                    </h5>

                                                </div>
                                                <div class="m-portlet__body" formGroupName="otherInformation">
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Candidate Assessed till date
                                                                :</label>
                                                            <input type="email"
                                                                formControlName="candidatesAssessedTillDate"
                                                                class="form-control m-input m-input--solid" disabled
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Total Staff:</label>
                                                            <input type="email" formControlName="numberOfAdminStaff"
                                                                class="form-control m-input m-input--solid" disabled
                                                                id="exampleInputEmail1" aria-describedby="emailHelp">
                                                        </div>

                                                    </div>
                                                    <div class="row">
                                                        <div class="form-group m-form__group col-lg-6">
                                                            <label for="exampleInputEmail1">Working under other Projects
                                                                :</label>
                                                            <textarea class="form-control m-input m-input--air" disabled
                                                                formControlName="workingUnderOtherProject"
                                                                id="exampleTextarea" rows="3"></textarea>

                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label for="exampleInputEmail1">Key achievements :</label>
                                                            <textarea class="form-control m-input m-input--air" disabled
                                                                formControlName="keyAchievements" id="exampleTextarea"
                                                                rows="3"></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div class="tab-pane" id="certifications">
                                    <form class="m-form m-form--fit m-form--label-align-right">
                                        <div class="m-portlet__body"
                                            *ngIf="assessmentAgencyData && assessmentAgencyData.AssessmentAgencyAffiliation && assessmentAgencyData.AssessmentAgencyAffiliation==='Company' ||
											 assessmentAgencyData && assessmentAgencyData.AssessmentAgencyAffiliation && assessmentAgencyData.AssessmentAgencyAffiliation==='Society'">
                                            <div class="m-content">
                                                <h5 class="padding">
                                                    PAN Details
                                                </h5>

                                            </div>
                                            <div class="row">
                                                <div class="m-portlet__body">
                                                    <div class="form-group col-lg-12 m-form__group row">
                                                        <label for="pannumber" class="col-3 col-form-label">PAN
                                                            Number:</label>
                                                        <div class="col-lg-6">
                                                            <input class="form-control m-input" type="text" disabled
                                                                [value]=panNumber id="pannumber">
                                                        </div>
                                                        <div (click)="opeFile(panDocument)" style="cursor:pointer"
                                                            class="col-3 preview-uploaded-file">
                                                            Preview Uploaded File
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="m-portlet__body"
                                            *ngIf="assessmentAgencyData && assessmentAgencyData.AssessmentAgencyAffiliation && assessmentAgencyData.AssessmentAgencyAffiliation==='Company'">
                                            <div class="m-content">
                                                <h5 class="padding">
                                                    GST Details
                                                </h5>

                                            </div>
                                            <div class="row">
                                                <div class="m-portlet__body">
                                                    <div class="form-group col-lg-12 m-form__group row">
                                                        <label for="gstnumber" class="col-3 col-form-label">GST Number
                                                            :</label>
                                                        <div class="col-lg-6">
                                                            <input class="form-control m-input" type="text" disabled
                                                                [value]=gstNumber id="gstnumber">
                                                        </div>
                                                        <div (click)="opeFile(gstDocument)" style="cursor:pointer"
                                                            class="col-3 preview-uploaded-file">
                                                            Preview Uploaded File
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="m-portlet__body">

                                            <div class="m-content">
                                                <h5 class="padding">
                                                    Financial Details
                                                </h5>

                                            </div>
                                            <!-- <div *ngIf="assessmentAgencyDataForm.value.financialYearwiseTurnOverDetail" class="row">
													<div class="m-portlet__body">
														<div class="form-group col-lg-12 m-form__group row">
															<label for="example-text-input" class="col-7 col-form-label">Year of Establishment:</label>
															<div class="col-5">
																<input class="form-control m-input" type="text" formControlName="yearOfEstablishmentDetails" disabled
																 id="example-text-input">
															</div>
														</div>
													</div>
												</div> -->

                                            <div class="row">
                                                <div class="m-portlet__body">
                                                    <div class="form-group col-lg-12 m-form__group row"
                                                        *ngFor="let finance of financialTurnOver">
                                                        <label for="example-text-input"
                                                            class="col-3 col-form-label">Financial Year
                                                            {{finance.duration.startYear}}-{{finance.duration.endYear}}
                                                            ( INR in Lakhs ):</label>
                                                        <div class="col-lg-6">
                                                            <input class="form-control m-input" type="text"
                                                                [disabled]="true" [value]=finance.annualTurnOver
                                                                id="example-text-input">
                                                        </div>
                                                        <div (click)="opeFile(finance.supportingCACertificate)"
                                                            style="cursor:pointer" class="col-3 preview-uploaded-file">
                                                            Preview Uploaded File
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                                <div class="tab-pane " id="education">
                                    <form class="m-form m-form--fit m-form--label-align-right">
                                        <div>
                                            <div>
                                                <div>
                                                    <div class="m-portlet__head">
                                                        <div class="m-portlet__head-caption">
                                                            <div class="m-portlet__head-title">
                                                                <h3 class="m-portlet__head-text m--font-primary">
                                                                    <span class="heading-style">Empanelled SSC</span>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <table class="notranslate table table-striped m-table"
                                                        *ngIf="assessmentAgencyData && assessmentAgencyData.linkedSectors && assessmentAgencyData.linkedSectors !== undefined">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Sector
                                                                </th>
                                                                <th>
                                                                    Sub - Sector
                                                                </th>
                                                                <th>
                                                                    SSC Name
                                                                </th>
                                                                <th>
                                                                    State
                                                                </th>
                                                                <th>
                                                                    District
                                                                </th>
                                                                <th>
                                                                    Empanellment duration
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody
                                                            *ngFor="let data of assessmentAgencyData.linkedSectors, let i = index;">
                                                            <tr *ngFor="let subSec of data.subSectors">
                                                                <td>{{data?.name}}</td>
                                                                <td>{{subSec?.name}}</td>
                                                                <td>{{data?.sscName}}</td>
                                                                <td>
                                                                    <span
                                                                        *ngFor="let state of subSec.jobRoles; first as f">
                                                                        <span
                                                                            *ngIf="f == true">{{state.state.name}}</span>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span
                                                                        *ngFor="let state of subSec.jobRoles ; index as j ; first as f">
                                                                        <span
                                                                            *ngIf="f==true">{{state.state.districts[j].name}}</span>
                                                                    </span>
                                                                </td>
                                                                <td>{{data.empanelmentDuration.from | date:'dd-MMM-yyyy'}}
                                                                    to
                                                                    {{data.empanelmentDuration.to |date :'dd-MMM-yyyy'}}
                                                                </td>
                                                                <!-- <td>
																		<div class="dropdown dropup">
																			<a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
																			 data-toggle="dropdown" aria-expanded="false">
																				<i class="la la-ellipsis-h"></i>
																			</a>
																			<div class="dropdown-menu dropdown-menu-right" x-placement="top-end" style="position: absolute; transform: translate3d(-132px, -143px, 0px); top: 0px; left: 0px; will-change: transform;">
																				<a class="dropdown-item">View Details</a>
																			</div>
																		</div>
																	</td> -->
                                                            </tr>
                                                            <!-- <tr *ngIf="sscData.length === 0" style="color:grey;font-size:17px">
																<td colspan="8">
																	<p style="text-align:center;">No Data Found</p>
																</td>
															</tr> -->
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div>
                                                    <div class="m-portlet__head">
                                                        <div class="m-portlet__head-caption">
                                                            <div class="m-portlet__head-title">
                                                                <h3 class="m-portlet__head-text m--font-primary">
                                                                    <span class="heading-style">Associated
                                                                        Assessors</span>
                                                                </h3>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="m-portlet__head-tools">
																<ul class="m-portlet__nav">
																	<li class="m-portlet__nav-item">
																		<button type="button" class="btn m-btn--pill    btn-outline-info btn-sm m-btn m-btn--custom">Link
																			Assessors</button>
																	</li>

																</ul>
															</div> -->
                                                    </div>
                                                    <table class="notranslate table table-striped m-table">
                                                        <thead>
                                                            <tr>
                                                                <th>
                                                                    Assessor ID
                                                                </th>
                                                                <th>
                                                                    Assessor Name
                                                                </th>
                                                                <th>
                                                                    Mobile
                                                                </th>
                                                                <th>
                                                                    Email
                                                                </th>
                                                                <th>
                                                                    Linking Type
                                                                </th>
                                                                <th>
                                                                    Valid From
                                                                </th>
                                                                <th>
                                                                    Valid To
                                                                </th>
                                                                <!-- <th>
																	Action
																</th> -->
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let linkedAA of associateAa">
                                                                <td>{{linkedAA.userName?linkedAA.userName: 'N/A'}}</td>
                                                                <td>{{linkedAA.name?linkedAA.name: 'N/A'}}</td>
                                                                <td>{{linkedAA.phone?linkedAA.phone: 'N/A'}}</td>
                                                                <td>{{linkedAA.email?linkedAA.email: 'N/A'}}</td>
                                                                <td>{{linkedAA.associations?.linkedType?linkedAA.associations.linkedType: 'N/A'}}
                                                                </td>
                                                                <td>{{linkedAA.associations?.validity?.fromDate?(linkedAA.associations.validity.fromDate | date: 'dd-MMM-yyyy'): 'N/A'}}
                                                                </td>
                                                                <td>{{linkedAA.associations?.validity?.toDate?(linkedAA.associations.validity.toDate | date: 'dd-MMM-yyyy' ): 'N/A'}}
                                                                </td>
                                                                <!-- <td>
																	<div class="dropdown dropup">
																		<a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="false">
																			<i class="la la-ellipsis-h"></i>
																		</a>
																		<div class="dropdown-menu dropdown-menu-right" x-placement="top-end" style="position: absolute; transform: translate3d(-132px, -143px, 0px); top: 0px; left: 0px; will-change: transform;">
																			<a class="dropdown-item">View Details</a>
																			<a class="dropdown-item">Delinked</a>
																		</div>
																	</div>
																</td> -->
                                                            </tr>
                                                            <!-- <tr *ngIf="associateAa.length === 0" style="color:grey;font-size:17px">
																<td colspan="8">
																	<p style="text-align:center;">No Data Found</p>
																</td>
															</tr> -->
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>